module.exports = __webpack_public_path__ + "img/full2-min.c1fc0b96.png";